import React from 'react';
import { Layout, Typography } from 'antd';
import AixueFooter from '@/components/AixueFooter/index';
import styles from './index.module.scss';
import Screen1 from './Screen1';
import Screen2 from './Screen2';
import Screen3 from './Screen3';
import Screen4 from './Screen4';
import Screen5 from './Screen5';

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export default function AixueAi() {
  return (
    <div className={`${styles.container} aixue-ai-scroll`}>
      <Screen1 />
      <Screen2 />
      <Screen3 />
      <Screen4 />
      <Screen5 />
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
